import React from 'react'
import styled from 'styled-components'
import { ContainerHeadingActionIcon, HeaderRow, HeaderCell,
  UnitsRow, UnitCell, DataRow, DataCell, Table, THead, TBody, DataTableModalContainer,
  TableContainer } from './styled-elements'
import CloseCircle from '../icons/CloseCircle'
import ContainerHeading from '../layout/ContainerHeading'
import HelmetTitle from '../../components/layout/HelmetTitle'
import Moment from 'moment-timezone'

const CustomHeaderCell = styled(HeaderCell)`
  max-width: unset;
  text-align: left;
  padding-right: 40px;
  ${({right}) => (right===true) ? 'text-align: right;' : 'text-align: left;'}
`

const CustomDataCell = styled(DataCell)`
  max-width: unset;
  padding-right: 40px;
  ${({right}) => (right===true) ? 'text-align: right;' : 'text-align: left;'}
`

export default class DataRetrievalsTable extends React.Component {

  componentDidMount = () => {
  }

  renderTable = (data,site) => {
    const colCount = data.headers[0].length
    const Row1 = data.headers && data.headers[0] && <HeaderRow key={0}>{data.headers[0].map((header, index) => <CustomHeaderCell key={index} first={(index===0)} right={(index===4)}>{header}</CustomHeaderCell>)}<CustomHeaderCell key={colCount} /></HeaderRow>
    const Row2 = data.headers && data.headers[1] && <UnitsRow key={1}>{data.headers[1].map((unit, index) => <UnitCell key={index} first={(index===0)}>{unit}</UnitCell>)}<UnitCell key={colCount} /></UnitsRow>
    const DataRows = data.data.map((row,rowIndex) => {
      const moment = Moment.tz(row[0],site.timezone_name)
      const momentPart1 = moment.format('YYYY-MM-')
      const momentPart2 = moment.format('DD')
      const momentPart3 = moment.format('kk:mm')
      const timeFromStr = Moment.tz(row[1],site.timezone_name).format('YYYY-MM-DD kk:mm')
      const timeToStr = Moment.tz(row[2],site.timezone_name).format('YYYY-MM-DD kk:mm')
      return <DataRow key={rowIndex}>
        <CustomDataCell key={0}>{momentPart1}<strong>{momentPart2}</strong> | <strong>{momentPart3}</strong></CustomDataCell>
        <CustomDataCell key={1}>{timeFromStr}</CustomDataCell>
        <CustomDataCell key={2}>{timeToStr}</CustomDataCell>
        <CustomDataCell key={3}>{row[3]}</CustomDataCell>
        <CustomDataCell right key={4}>{row[4]}</CustomDataCell>
        <CustomDataCell key={colCount} />
      </DataRow>
    })
    return <Table>
      <THead>
        {Row1}
        {Row2}
      </THead>
      <TBody>
        {DataRows}
      </TBody>
    </Table>
  }

  renderBody = (props,state) => {
    if ( !props.data || !props.data.headers || !props.data.data ) return null
    const { site, dataView, data } = props
    const title = `${site.name}: ${dataView.name}`
    return <DataTableModalContainer>
      <HelmetTitle title={title} />
      <ContainerHeading
        title={title}
        actionIcons={
          <ContainerHeadingActionIcon onClick={this.props.closeDataViewHandler}><CloseCircle /></ContainerHeadingActionIcon>
        }
      />
      <TableContainer>
        {this.renderTable(data,site)}
      </TableContainer>
    </DataTableModalContainer>
  }

  render = () => this.renderBody(this.props,this.state)

}



// WEBPACK FOOTER //
// ./src/components/dataViews/DataRetrievalsTable.js